import { render, staticRenderFns } from "./estates-item.vue?vue&type=template&id=39ded5c1&scoped=true&"
import script from "./estates-item.vue?vue&type=script&lang=js&"
export * from "./estates-item.vue?vue&type=script&lang=js&"
import style0 from "./estates-item.vue?vue&type=style&index=0&id=39ded5c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ded5c1",
  null
  
)

export default component.exports